import { render, staticRenderFns } from "./registroReestructuracion.vue?vue&type=template&id=edb6dc3c&scoped=true&"
import script from "./registroReestructuracion.component.ts?vue&type=script&lang=ts&"
export * from "./registroReestructuracion.component.ts?vue&type=script&lang=ts&"
import style0 from "./registroReestructuracion.vue?vue&type=style&index=0&id=edb6dc3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb6dc3c",
  null
  
)

export default component.exports